import { cn, toDisplayString } from "@/lib/utils";

export interface ProgressBarProps {
  value: number;
  max: number;
  label?: string;
  className?: string;
}

function toNumber(v: unknown): number {
  if (typeof v === "number" && !Number.isNaN(v)) return v;
  if (v != null && typeof v === "object" && "message" in v) return 0;
  const n = Number(v);
  return Number.isNaN(n) ? 0 : n;
}

export function ProgressBar({
  value,
  max,
  label,
  className,
}: ProgressBarProps) {
  const safeValue = toNumber(value);
  const safeMax = toNumber(max);
  const pct = safeMax > 0 ? Math.min(100, (safeValue / safeMax) * 100) : 0;
  const barColor =
    pct >= 95
      ? "bg-danger"
      : pct >= 80
        ? "bg-warning"
        : "bg-success";

  return (
    <div className={cn("space-y-1", className)}>
      {label != null && label !== "" && (
        <div className="flex justify-between text-sm">
          <span className="text-text-muted">{toDisplayString(label)}</span>
          <span className="text-text font-medium">
            {safeValue}
            {safeMax > 0 && ` / ${safeMax}`}
          </span>
        </div>
      )}
      <div className="h-2 w-full overflow-hidden rounded-full bg-surface-2">
        <div
          className={cn("h-full rounded-full transition-all duration-300", barColor)}
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={safeValue}
          aria-valuemin={0}
          aria-valuemax={safeMax}
        />
      </div>
    </div>
  );
}
